import { useInteractionStore } from '@/store/interactionStore';
import styles from './SpatialCanvas.module.css';

/** Alignment guides shown while dragging. Subscribes only to the guide list. */
export const SnapGuides = () => {
  const guides = useInteractionStore((s) => s.guides);
  if (guides.length === 0) return null;
  return (
    <>
      {guides.map((g, i) => (
        <div
          key={i}
          className={styles.guide}
          data-axis={g.axis}
          data-kind={g.kind}
          data-testid="snap-guide"
          style={
            g.axis === 'x'
              ? { left: g.at, top: g.from, height: g.to - g.from }
              : { top: g.at, left: g.from, width: g.to - g.from }
          }
        />
      ))}
    </>
  );
};
